import React from 'react';
import styles from './RangePicker.module.scss';
import DatePicker from 'react-datepicker';
import { getTranslation } from '../../../../../utils/translation';
import Select from 'react-select';

const RangePicker = ({
    periods,
    selectedPeriod,
    onPeriodChange,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    onSearch,
    onReset,
    showTime,
}) => {
    return (
        <>
            <div className={styles.rangePickerWrap}>
                <Select
                    className='common-select common-select--filters'
                    classNamePrefix='common'
                    menuPlacement={'auto'}
                    isSearchable={false}
                    value={selectedPeriod}
                    onChange={onPeriodChange}
                    getOptionLabel={option => option.label}
                    getOptionValue={option => option.key}
                    options={periods}
                />
                <label className={styles.rangePicker}>
                    <DatePicker
                        selected={startDate}
                        placeholderText={getTranslation('filtersStartDatePlaceholder')}
                        onChange={onStartDateChange}
                        dateFormat={`dd.MM.yyyy${showTime ? ' - HH:mm:ss' : ''}`}
                        timeFormat={'HH:mm:ss'}
                        showTimeInput={showTime}
                    />
                    <i className='icon-calendar' />
                </label>
                <span className='icon-calendar-arrow' />
                <label className={styles.rangePicker}>
                    <DatePicker
                        selected={endDate}
                        placeholderText={getTranslation('filtersEndDatePlaceholder')}
                        onChange={onEndDateChange}
                        dateFormat={`dd.MM.yyyy${showTime ? ' - HH:mm:ss' : ''}`}
                        timeFormat={'HH:mm:ss'}
                        showTimeInput={showTime}
                    />
                    <i className='icon-calendar' />
                </label>
                <button
                    className='filter-button m-l-3'
                    onClick={() => onSearch(startDate, endDate)}
                >
                    {getTranslation('filtersSearchButton')}
                </button>
                {onReset && (
                    <button className='filter-button m-l-3' onClick={onReset}>
                        {getTranslation('filtersClearButton')}
                    </button>
                )}
            </div>
        </>
    );
};

export default RangePicker;
